import { BaseOption } from '@/request/interface/experienceClassBooking';
import { ExperienceClassBookingSteps } from '../types';

export const WeekOptions = [
  { label: 'Mon', value: 1 },
  { label: 'Tue', value: 2 },
  { label: 'Wed', value: 3 },
  { label: 'Thu', value: 4 },
  { label: 'Fri', value: 5 },
  { label: 'Sat', value: 6 },
  { label: 'Sun', value: 0 },
];

export const AgeOptions: BaseOption<number>[] = [
  {
    label: '<3',
    value: 2,
  },
  ...Array.from({ length: 16 }).map((item, index) => ({ label: `${index + 3}`, value: index + 3 })),
  {
    label: '>18',
    value: 19,
  },
];

export const AdultAgeOptions: BaseOption<number>[] = [
  [3, 12],
  [13, 18],
  [18, 24],
  [25, 30],
  [31, 40],
  [41, 50],
  [51, 60],
]
  .map(([min, max]) => ({
    label: `${min} - ${max} Years old`,
    value: max,
  }))
  .concat({
    label: '61 Years and older',
    value: 61,
  });

export const HoursOptionMap: Record<'morning' | 'afternoonAndEvening', BaseOption[]> = {
  morning: [
    { label: '8 AM - 10 AM', value: '8-10' },
    { label: '10 AM - 12 PM', value: '10-12' },
  ],
  afternoonAndEvening: [
    { label: '12 PM - 2 PM', value: '12-14' },
    { label: '2 PM - 4 PM', value: '14-16' },
    { label: '4 PM - 6 PM', value: '16-18' },
    { label: '6 PM - 8 PM', value: '18-20' },
    { label: '8 PM - 10 PM', value: '20-22' },
  ],
};

/**
 * 语言选项
 */
export const LanguageOptions = [
  { label: 'Cantonese (Chinese)', value: '粤语' },
  { label: 'English', value: '英语' },
  { label: 'Japanese', value: '日语' },
  { label: 'French', value: '法语' },
  { label: 'German', value: '德语' },
  { label: 'Russian', value: '俄语' },
  { label: 'Korean', value: '韩语' },
  // { label: 'Cantonese', value: '中文普通话' },
  { label: 'Thai', value: '泰语' },
  { label: 'Indonesian', value: '印尼语' },
  { label: 'Spanish', value: '西班牙语' },
  { label: 'Singapore English', value: '新加坡英语' },
  { label: 'Arabic', value: '阿拉伯语' },
  { label: 'Italian', value: '意大利语' },
];

/**
 * 标准流程
 */
export const ExperienceClassBookingProcess = [
  ExperienceClassBookingSteps.FundamentalQuestionLearningTarget,
  ExperienceClassBookingSteps.FundamentalQuestionLearningExperience,
  ExperienceClassBookingSteps.FundamentalQuestionAge,
  // 去掉四个步骤
  // ExperienceClassBookingSteps.FundamentalQuestionClassTime,
  ExperienceClassBookingSteps.FilterTeachers,
  ExperienceClassBookingSteps.ConfirmTeacher,
  ExperienceClassBookingSteps.ConfirmTeacherResult,
  ExperienceClassBookingSteps.ExtendedQuestionChildName,
  ExperienceClassBookingSteps.ExtendedQuestionEmail,
  // 移除联系语言步骤
  // ExperienceClassBookingSteps.ExtendedQuestionContactLanguage,
  // 移除手机号步骤
  // ExperienceClassBookingSteps.ExtendedQuestionPhoneNumber,
  ExperienceClassBookingSteps.ExtendedQuestionResult,
];

/**
 *
 * 支持外部跳转的步骤
 */
export type supportedAssignSteps = [
  ExperienceClassBookingSteps.FundamentalQuestionLearningTarget,
  ExperienceClassBookingSteps.FilterTeachers,
  ExperienceClassBookingSteps.ConfirmTeacher,
];
